/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import injectSheet from 'react-jss';

import Filter from './Filter';
import SelectionToolbar from './SelectionToolbar';

import Kpi from './Kpi';
import Table from './Table';
// import QTable from './QTable';
// import QTableAlt from './QTableAlt';
import MuiTable from './MuiTable';
import Bar from './Bar';
import BarGoals from './BarGoals';
import Distribution from './Distribution';
import Donut from './Donut';

import tableTeamQProp from '../../config/hypercubeDefs/tableTeamsQProp';
import tablePlayersQProp from '../../config/hypercubeDefs/tablePlayersQProp';

import TournamentsStyles from './Toutnaments_Styles';

const styles = TournamentsStyles;

const Tournaments = ({ classes }) => (
  <div className={classes.wrapper}>
    <div className={classes.header} style={{ borderBottom: '1px solid lightgray', fontSize: 26 }}>
      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '10px 0' }}>
        <div className={classes.nav} style={{ color: '#000000' }}>
          TOURNAMENT STATS
        </div>
        <div className={classes.nav}>
          {/* <div className={classes.liveResults}>Live</div> */}
          <Link to="/historical-analysis/currentTournament/" style={{ textDecoration: 'none', color: '#959595', '&:hover': { color: '#7F1431' } }}>
            2022 RESULTS
          </Link>
        </div>
      </div>
    </div>
    <div className={classes.kpis}>
      <div className={classes.kpi} style={{ backgroundImage: "url('assets/images/host-countries.png')", backgroundPosition: 'center' }}>
        <div className={classes.kpititle}>Editions</div>
        <div className={classes.kpinum}>
          <Kpi measure="Count( {1<[tournament_edition]=, [team_name]=>} DISTINCT tournament_id)" />
        </div>
      </div>

      <div className={classes.kpi} style={{ backgroundImage: "url('assets/images/winners.png')" }}>
        <div className={classes.kpititle}>Winners</div>
        <div className={classes.kpinum}>
          <Kpi measure="Count( {1<winner -= {''}, [tournament_edition]=, [team_name]=>} DISTINCT winner)" />
          <div className={classes.kpisuffix}>Brazil, Germany, Italy, Argentina, Uruguay, France, Spain, England</div>
        </div>

      </div>
      <div className={classes.kpi} style={{ backgroundImage: "url('assets/images/france.png')" }}>
        <div className={classes.kpititle}>Current Champion</div>
        <div className={classes.kpinum}>
          <div className={classes.kpitext}>France</div>
          <div className={classes.kpisuffix}>
            2018
            <br />
            Hosted in Russia
          </div>
        </div>

      </div>
      <div className={classes.kpi} style={{ backgroundImage: "url('assets/images/brazil.png')" }}>
        <div className={classes.kpititle}>Top Team (All Time)</div>
        <div className={classes.kpinum}>
          <div className={classes.kpitext}>Brazil</div>
          <div>
            <div className={classes.kpisuffix}>5 Championships</div>
            <div className={classes.kpisuffix}>1958, 1962, 1970, 1994, 2002</div>
          </div>
        </div>

      </div>
      <div className={classes.kpi} style={{ backgroundImage: "url('assets/images/pele.png')" }}>
        <div className={classes.kpititle}>Top Player (All Time)</div>
        <div className={classes.kpinum}>
          <div className={classes.kpitext}>Pelé</div>
          <div>
            <div className={classes.kpisuffix}>3 Championships</div>
            <div className={classes.kpisuffix}>1958, 1962, 1970</div>
          </div>
        </div>
      </div>
    </div>

    <div className={classes.content}>
      <div className={classes.sidebar} style={{ display: window.innerWidth < 1080 ? 'none' : 'block' }}>

        <div className={classes.sectionTitle}>
          Filters
        </div>
        <Filter
          field="tournament_edition"
          sort={{ qSortByState: 1, qSortByExpression: -1, qExpression: { qv: 'year' } }}
          title="Edition"
          height="25vh"
        />
        <Filter
          field="team_name"
          sort={{ qSortByAscii: 1, qSortByState: 1 }}
          title="Team"
          height="25vh"
        />
      </div>
      <div className={classes.contentcharts}>
        <div>
          <div className={classes.selectionsTitles}>
            Selections
          </div>
          <SelectionToolbar />
        </div>
        <div className={classes.sectionTitle}>
          Rankings
        </div>
        <div className={classes.chartdescription} style={{ marginBottom: 30 }}>
          Check All-Time performers and use the filters sidebar to customize the ranking tables.
          Select a year to see who scored the most or pick a team and discover who was their youngest
          player in the tournament ever.
        </div>
        <div className={classes.tablesrow}>
          <div className={classes.table}>
            <div className={classes.charttitle}>Top Scorers</div>
            <Table
              sortCol={1}
              colStyles={[{}, { justifyContent: 'flex-end' }]}
              dimensions={[
                {
                  qDef: {
                    qFieldDefs: ['player_name'],
                  },
                  qNullSuppression: true,
                  qOtherTotalSpec: { qOtherMode: 'OTHER_COUNTED', qOtherCounted: '25', qSuppressOther: true },
                  qAttributeExpressions: [{ qExpression: '=only(team_code)' }],
                },
              ]}
              measures={[
                {
                  qDef: {
                    qDef: '=COUNT(DISTINCT goal_id)',
                  },
                  qSortBy: {
                    qSortByNumeric: -1,
                  },
                },
              ]}
            />
          </div>

          <div className={classes.table}>
            <div className={classes.charttitle}>Most Participations</div>
            <Table
              firstColIsId
              sortCol={2}
              dimensions={[
                {
                  qDef: {
                    qFieldDefs: ['player_id'],
                  },
                  qOtherTotalSpec: { qOtherMode: 'OTHER_COUNTED', qOtherCounted: '25', qSuppressOther: true },
                  qAttributeExpressions: [{ qExpression: '=only(team_code)' }],
                  qNullSuppression: true,
                },
                {
                  qDef: {
                    qFieldDefs: ['player_name'],
                  },
                  qAttributeExpressions: [{ qExpression: '=only(team_code)' }],
                  qNullSuppression: true,
                },
              ]}
              measures={[
                {
                  qDef: {
                    qDef: '=Count(DISTINCT  tournament_id)',
                  },
                  qSortBy: {
                    qSortByNumeric: -1,
                  },
                },
              ]}
            />

          </div>

          <div className={classes.table}>
            <div className={classes.charttitle}>Oldest Players</div>

            <Table
              sortCol={0}
              qHeight={25}
              colStyles={[{}, { justifyContent: 'flex-end' }]}
              age
              dimensions={[
                {
                  qDef: {
                    qFieldDefs: ['player_name'],
                    qSortCriterias: [
                      {
                        qSortByExpression: -1,
                        qExpression: {
                          qv: 'Num(MakeDate(Year(Max(DATE(match_date))), Month(Max(DATE(match_date))), Day(Max(DATE(match_date)))))-Num(birth_date)',
                        },
                      },
                    ],
                  },
                  qAttributeExpressions: [{ qExpression: '=only(team_code)' }],
                },
              ]}
              measures={[
                {
                  qDef: {
                    qDef: 'Num(MakeDate(Year(Max(DATE(match_date))), Month(Max(DATE(match_date))), Day(Max(DATE(match_date)))))-Num(birth_date)',
                  },
                  qSuppressMissing: true,
                },
              ]}
            />
          </div>

          <div className={classes.table}>
            <div className={classes.charttitle}>Youngest Players</div>
            <Table
              sortCol={0}
              qHeight={25}
              colStyles={[{}, { justifyContent: 'flex-end' }]}
              age
              dimensions={[
                {
                  qDef: {
                    qFieldDefs: ['player_name'],
                    qSortCriterias: [
                      {
                        qSortByExpression: 1,
                        qExpression: {
                          qv: 'Num(MakeDate(Year(Max(DATE(match_date))), Month(Max(DATE(match_date))), Day(Max(DATE(match_date)))))-Num(birth_date)',
                        },
                      },
                    ],
                  },
                  qAttributeExpressions: [{ qExpression: '=only(team_code)' }],
                },
              ]}
              measures={[
                {
                  qDef: {
                    qDef: 'Num(MakeDate(Year(Max(DATE(match_date))), Month(Max(DATE(match_date))), Day(Max(DATE(match_date)))))-Num(birth_date)',
                  },
                  qSuppressMissing: true,
                },
              ]}
            />
          </div>
        </div>
        <div className={classes.charttitle} style={{ marginTop: 20 }}>Teams Ranking</div>
        <div className={classes.chartdescription}>
          See every nation
          {'\''}
          s performance in the tournament.
          Teams are ranked right to left based on their previous years final positions.
          Each dot represents a tournament year. Past champions
          {'\''}
          {' '}
          dots are colored.

          <p style={{ marginTop: 10 }}>
            With five tournament wins Brazil ranks top of the list.
            Germany
            {'\''}
            s condensed dot distribution indicates they are consistently a great contender.
          </p>
        </div>

        <div>
          <Distribution
            object="JhFj"
          />
        </div>
        <div className={classes.legendTeamsRanking}>
          <div className={classes.legend}>
            <div className={classes.legendRank}>
              <span style={{
                width: '10px', height: '10px', backgroundColor: 'gold', borderRadius: '100%', display: 'inline-block',
              }}
              />
              {' '}
              Champion
            </div>
            <div className={classes.legendTeams}>
              <div>Brazil(5)</div>
              <div>Germany(4)</div>
              <div>Italy(4)</div>
              <div>Argentina(2)</div>
              <div>Uruguay(2)</div>
              <div>France(2)</div>
              <div>England(1)</div>
              <div>Spain(1)</div>
            </div>
          </div>
          <div className={classes.legend}>
            <div className={classes.legendRank}>
              <span style={{
                width: '10px', height: '10px', backgroundColor: 'silver', borderRadius: '100%', display: 'inline-block',
              }}
              />
              {' '}
              Runner-up
            </div>
            <div className={classes.legendTeams}>
              <div>Germany(4)</div>
              <div>Argentina(3)</div>
              <div>Netherlands(3)</div>
              <div>Brazil(2)</div>
              <div>Italy(2)</div>
              <div>Czechoslovakia(2)</div>
              <div>Hungary(2)</div>
              <div>France(1)</div>
              <div>Sweden(1)</div>
              <div>Croatia(1)</div>
            </div>
          </div>
          <div className={classes.legend}>
            <div className={classes.legendRank}>
              <span style={{
                width: '10px', height: '10px', backgroundColor: '#CD7F32', borderRadius: '100%', display: 'inline-block',
              }}
              />
              {' '}
              3rd Place
            </div>
            <div className={classes.legendTeams}>
              <div>Germany(4)</div>
              <div>France(2)</div>
              <div>Brazil(2)</div>
              <div>Poland(2)</div>
              <div>Sweden(2)</div>
              <div>Austria(1)</div>
              <div>Belgium(1)</div>
              <div>Chile(1)</div>
              <div>Croatia(1)</div>
              <div>Italy(1)</div>
              <div>Netherlands(1)</div>
              <div>Portugal(1)</div>
              <div>Turkey(1)</div>
              <div>United States(1)</div>
            </div>
          </div>
          <div className={classes.legend}>
            <div className={classes.legendRank}>
              <span style={{
                width: '10px', height: '10px', backgroundColor: '#484848', borderRadius: '100%', display: 'inline-block',
              }}
              />
              {' '}
              4th Place
            </div>
            <div className={classes.legendTeams}>
              <div>Uruguay(3)</div>
              <div>Brazil(2)</div>
              <div>England(2)</div>
              <div>Yugoslavia(2)</div>
              <div>Austria(1)</div>
              <div>Belgium(1)</div>
              <div>Bulgaria(1)</div>
              <div>France(1)</div>
              <div>Italy(1)</div>
              <div>Korea Republic(1)</div>
              <div>Netherlands(1)</div>
              <div>Portugal(1)</div>
              <div>Soviet Union(1)</div>
              <div>Spain(1)</div>
              <div>Sweden(1)</div>
              <div>Germany(1)</div>
            </div>
          </div>
        </div>
        <div className={classes.sectionTitle} style={{ marginTop: 20 }}>
          Goals analysis
        </div>
        <div className={classes.chartdescription} style={{ marginBottom: 30 }}>
          Learn all about goals during the World Cup. What tournament saw more goals scored?
          Check when most of the goals are scored during the competition and discover all about your favorite team
          {'\''}
          s goals.
        </div>

        <div className={classes.twoCharts} style={{ flexGrow: 1 }}>
          <div className={classes.charttitle}>Goals scored by Tournament</div>
          <Bar object="90cbb8aa-2697-48cd-b2d1-af3940c0820f" />
        </div>
        <div className={classes.twoCharts} style={{ flexGrow: 1 }}>
          <div className={classes.charttitle}>Goals Scored by Team</div>
          <Bar object="0ca151cf-2433-4098-8a43-d50931703330" />
        </div>
        <div className={classes.charttitle} style={{ marginTop: 60 }}>Goals Scored by Period</div>
        <div className={classes.twoColCharts}>
          <div className={classes.twoCharts} style={{ flexGrow: 1 }}>
            <Donut />
          </div>

          <div className={classes.twoCharts} style={{ flexGrow: 1 }}>
            <BarGoals />
          </div>
        </div>
        <div className={classes.sectionTitle} style={{ marginTop: 30 }}>
          Team and player Stats
        </div>
        <div className={classes.chartdescription}>
          Team and individual player stats are provided in the two tables below. You can select teams and players to see their associated data.
          You can also sort the tables by column to see the leaders or laggards in each metric.
        </div>
        <div className={classes.charttitle} style={{ marginTop: 30 }}>
          Team stats
        </div>
        <div>
          {/* <QTableAlt object="PCZjDW" /> */}
          <MuiTable type="team" qProps={tableTeamQProp} />
        </div>
        <div className={classes.charttitle}>
          Player Stats
        </div>
        <div style={{ flex: 1 }}>
          <MuiTable type="player" qProps={tablePlayersQProp} />
        </div>
      </div>
    </div>
  </div>
);

Tournaments.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(Tournaments);
